import "rc-slider/assets/index.css";

import { Props } from "../types";

const CalculatorMobile = ({ keyzyBudget, onHowIsPossible }: Props) => {

  return (
    <div className="relative mt-9">
      <div className="flex flex-col items-start mb-5">
        <h3 className="text-lg font-bold ">Your home buying budget</h3>
        <span className="my-3 text-2xl font-bold text-landing-cherry">
          {keyzyBudget?.indicativeBudget}
        </span>
        <h4 className="text-base text-landing-orange font-bold ">
          Rent to own a home in 2-3 years
        </h4>
      </div>
      <div className="w-full h-px mx-auto my-5 bg-landing-gray" />
      <div className="flex flex-col items-start mb-5">
        <h3 className="text-lg font-bold ">Fixed rent for 2-3 years</h3>
        <span className="my-3 text-2xl font-bold text-landing-cherry">{keyzyBudget?.rent}</span>
        <h4 className="text-base text-landing-orange font-bold ">
          No hikes and get it all back at the end!
        </h4>
      </div>

      <div className="w-full h-px mx-auto my-5 bg-landing-gray" />

      <div className="flex flex-col items-start">
        <h3 className="text-lg font-bold ">Build up a 10% deposit</h3>
        <span className="my-3 text-2xl font-bold text-landing-cherry">{keyzyBudget?.deposit}</span>
        <h4 className="text-base text-landing-orange font-bold">100% rent refunded when you buy</h4>
        <span
          onClick={onHowIsPossible}
          className="my-3 text-base font-bold text-landing-cherry border-landing-blue  underline cursor-pointer"
        >
          How is this possible?
        </span>
      </div>
    </div>
  );
};

export default CalculatorMobile;
